import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { updateGame } from "./ggame";
import { updateUserBalance } from "./userbal";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authRedeemSlice = createSlice({
  name: "redeemauth",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const {     } =
  authRedeemSlice.actions;

export const RedeemSlice = (data) => async (dispatch) => {
  try {
    // dispatch(requestStart());
    // dispatch(loadingStart());
    const response = await axios.post(`/private/user/radeem`, data);
    if (response?.status === 200) {
      const { game, balance } = response.data;
      // dispatch(GetBlanceSlice(data));
      // dispatch(ApiSuccess(response.data));
      dispatch(updateGame(game));
      dispatch(updateUserBalance(balance));
      toast.success(`Your ${data?.name} Radeem Request success`);
      // dispatch(closeModal("Created successfully!"));
      // dispatch(loadingSuccess("radeem successfully!"));
    } else if (response?.status === 202) {
      Object.assign(data, { query: "256" });
      // dispatch(ApiSuccess(response.data));
      toast.success(`${data?.name} Radeem Request in progress!`);
      // dispatch(closeModal("Created successfully!"));
      // dispatch(loadingSuccess("radeem successfully!"));
    }
    return true;
  } catch (err) {
    toast.error(
      err?.response?.data?.message ||
        err.message ||
        err.msg ||
        err?.response?.message
    );
    // dispatch(loadingFailure(err.msg));
    // dispatch(closeModal(""));
    // dispatch(
    //   requestFailure(err?.response?.data?.message || "Something went wrong!")
    // );
    return false;
  }
};

export default authRedeemSlice.reducer;
